import * as React from "react";
import Navbar from "../component/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import MetaTags from "../component/MetaTags";
import { motion } from "framer-motion";
import LanguageLandingHero from "../component/LanguageLanding/LanguageLandingHero";
import LanguageLandingFeatures from "../component/LanguageLanding/LanguageLandingFeatures";
import LanguageLandingCourses from "../component/LanguageLanding/LanguageLandingCourses";
import LanguageLandingSteps from "../component/LanguageLanding/LanguageLandingSteps";
import DemoBookingForm from "../component/LanguageLanding/DemoBookingForm";
import GoogleReviews from "../component/Home/GoogleReview";
import StudentStats from "../component/Home/StudentStats";
import CEOMessage from "../component/Home/CEOMessage";
import VideoReviews from "../component/Reviews/VideoReviews";
import JlptVideos from "../component/Home/JlptVideos";
import OfferBanner from "../component/Home/OfferBanner";
import JapanGeoRedirect from "../component/JapanGeoRedirect";

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      activeTab: "japanese",
      formLanguage: "",
      formLevel: "",
    };
  }

  scrollToForm = () => {
    if (typeof window !== "undefined" && this.formRef.current) {
      this.formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  scrollToCourses = () => {
    if (typeof window !== "undefined") {
      document
        .getElementById("ll-courses")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  handleBookDemo = (language, level, tab) => {
    this.setState(
      {
        formLanguage: language,
        formLevel: level,
        activeTab: tab || this.state.activeTab,
      },
      this.scrollToForm
    );
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const pageVariants = {
      initial: { opacity: 0 },
      in: { opacity: 1 },
      out: { opacity: 0 },
    };

    const { activeTab, formLanguage, formLevel } = this.state;

    return (
      <>
        <JapanGeoRedirect />
        <Navbar />
        <motion.div
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
        >
          <main className="ll-page">
            <LanguageLandingHero
              onBookDemo={this.scrollToForm}
              onExploreCourses={this.scrollToCourses}
            />

            <LanguageLandingFeatures />

            <LanguageLandingCourses
              activeTab={activeTab}
              onTabChange={this.handleTabChange}
              onBookDemo={this.handleBookDemo}
            />

            <LanguageLandingSteps />

            <StudentStats />

            <VideoReviews />

            <JlptVideos />

            <CEOMessage />

            <div className="ll-section ll-google-reviews">
              <GoogleReviews />
            </div>

            <OfferBanner />

            <section id="ll-demo-form" className="ll-section ll-demo-form" ref={this.formRef}>
              <div className="container">
                <header className="section-header wow fadeInUp">
                  <span className="ll-section-label">Free Demo</span>
                  <h2 className="about_head">
                    Book Your{" "}
                    <span className="highlighted-text">FREE Demo Class Today</span>
                  </h2>
                  <p className="ll-section-subtitle">
                    Limited seats available. No payment required.
                  </p>
                </header>
                <div className="ll-demo-form__wrapper wow fadeInUp">
                  <DemoBookingForm
                    initialLanguage={formLanguage}
                    initialLevel={formLevel}
                  />
                </div>
              </div>
            </section>
          </main>

          <Footer />
        </motion.div>

        <MetaTags
          title="Koderbox | Learn Japanese, German, French & Coding Online"
          description="Koderbox offers live online foreign language courses (Japanese, German, French, Spanish, Korean, Chinese) and coding courses with expert trainers. Flexible timings, affordable fees. Book your free demo class today!"
          path="/"
        />
      </>
    );
  }
}

export default IndexPage;
